var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M3.75,0h248.5c2.071,0,3.75,1.679,3.75,3.75v243.125c0,5.04-4.085,9.125-9.125,9.125H3.75  C1.679,256,0,254.321,0,252.25V3.75C0,1.679,1.679,0,3.75,0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M88.287,128c0-10.962,4.442-20.886,11.623-28.072L66.636,90.41   c-1.931-0.553-3.316,1.846-1.872,3.242l24.899,24.075l-33.601,8.4c-1.949,0.487-1.949,3.257,0,3.744l33.601,8.4l-24.899,24.075   c-1.444,1.396-0.059,3.795,1.872,3.242l33.274-9.518C92.729,148.886,88.287,138.962,88.287,128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M99.928,99.911c7.186-7.181,17.11-11.623,28.072-11.623s20.886,4.442,28.072,11.623l9.518-33.274   c0.553-1.931-1.846-3.316-3.242-1.872l-24.075,24.899l-8.4-33.601c-0.487-1.949-3.257-1.949-3.744,0l-8.4,33.601l-24.077-24.9   c-1.396-1.444-3.795-0.059-3.242,1.872L99.928,99.911z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M156.072,156.09c-7.186,7.181-17.11,11.623-28.072,11.623c-10.961,0-20.886-4.442-28.072-11.623   l-9.518,33.274c-0.553,1.931,1.846,3.316,3.242,1.872l24.075-24.899l8.4,33.601c0.487,1.949,3.257,1.949,3.744,0l8.4-33.601   l24.075,24.899c1.396,1.444,3.795,0.059,3.242-1.872L156.072,156.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M199.938,126.128l-33.601-8.4l24.899-24.075c1.444-1.396,0.059-3.795-1.872-3.242l-33.274,9.518   c7.181,7.186,11.623,17.11,11.623,28.072c0,10.961-4.442,20.886-11.623,28.072l33.274,9.518c1.931,0.552,3.316-1.846,1.872-3.242   l-24.899-24.075l33.601-8.4C201.887,129.385,201.887,126.615,199.938,126.128z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F5F5F5"
    },
    cx: 128,
    cy: 128,
    r: 31.621
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/TW.872e2d5a088bf03e95cc5dc78945686b.svg";
export { ForwardRef as ReactComponent };